/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxGamesLibWebPublicDataBaseSupportOptions
 */
export interface FxGamesLibWebPublicDataBaseSupportOptions {
    /**
     * 
     * @type {string}
     * @memberof FxGamesLibWebPublicDataBaseSupportOptions
     */
    ZendeskEmbedKey?: string | null;
}

/**
 * Check if a given object implements the FxGamesLibWebPublicDataBaseSupportOptions interface.
 */
export function instanceOfFxGamesLibWebPublicDataBaseSupportOptions(value: object): value is FxGamesLibWebPublicDataBaseSupportOptions {
    return true;
}

export function FxGamesLibWebPublicDataBaseSupportOptionsFromJSON(json: any): FxGamesLibWebPublicDataBaseSupportOptions {
    return FxGamesLibWebPublicDataBaseSupportOptionsFromJSONTyped(json, false);
}

export function FxGamesLibWebPublicDataBaseSupportOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPublicDataBaseSupportOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'ZendeskEmbedKey': json['ZendeskEmbedKey'] == null ? undefined : json['ZendeskEmbedKey'],
    };
}

export function FxGamesLibWebPublicDataBaseSupportOptionsToJSON(json: any): FxGamesLibWebPublicDataBaseSupportOptions {
    return FxGamesLibWebPublicDataBaseSupportOptionsToJSONTyped(json, false);
}

export function FxGamesLibWebPublicDataBaseSupportOptionsToJSONTyped(value?: FxGamesLibWebPublicDataBaseSupportOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ZendeskEmbedKey': value['ZendeskEmbedKey'],
    };
}

